/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Store extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Store;


// WEBPACK FOOTER //
// ./src/routes/store/index.js